import { render } from "./ShiftSlot.vue?vue&type=template&id=2089ac15&scoped=true"
import script from "./ShiftSlot.vue?vue&type=script&lang=js"
export * from "./ShiftSlot.vue?vue&type=script&lang=js"

import "./ShiftSlot.vue?vue&type=style&index=0&id=2089ac15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2089ac15"]])

export default __exports__